const MODULE = document.querySelectorAll(
    '[data-module="lista_capacidades_section"]'
);

class ListaCapacidadesSection {
    constructor(component) {
        this.component = component;
        this.select = component.querySelector('[data-capacidades-select]');
        this.list = component.querySelector('[data-capacidades-lista]');
        this.cards = Array.from(
            this.list.querySelectorAll('[data-capacidade-id]')
        );
        this.empty = component.querySelector('[data-capacidades-empty]');
        this.status = component.querySelector('[data-capacidades-status]');

        this.init();
    }

    init() {
        if (this.component.hasAttribute('data-capacidades-initialized')) {
            return;
        }

        this.component.setAttribute('data-capacidades-initialized', 'true');
        this.select.addEventListener('change', () => {
            this.applyFilter();
        });
        this.applyFilter();
    }

    applyFilter() {
        const selectedCategory = this.select.value;
        let visibleCount = 0;

        this.cards.forEach((card) => {
            const categories = (card.dataset.capacidadeCategorias || '')
                .split(/\s+/)
                .filter(Boolean);
            const matches = selectedCategory === ''
                || categories.includes(selectedCategory);

            card.hidden = !matches;

            if (matches) {
                visibleCount += 1;
            }
        });

        this.list.hidden = visibleCount === 0;
        this.empty.hidden = visibleCount > 0;

        const label = visibleCount === 1
            ? this.status.dataset.labelSingular
            : this.status.dataset.labelPlural;

        this.status.textContent = `${visibleCount} ${label}`;
    }
}

MODULE.forEach((component) => {
    new ListaCapacidadesSection(component);
});

export default ListaCapacidadesSection;
